module.exports = __webpack_public_path__ + "static/media/oth.1e094baf.svg";